import i18next, { InterpolationOptions } from 'i18next'

const allowedLanguages: SupportedLanguage[] = ['de', 'en']
export type SupportedLanguage = 'de' | 'en'

/**
 * Reads the `lang` attribute from the <html> tag to determine the current language.
 * Defaults to 'en' if the lang attribute is not set.
 */
export const currentLanguage: string = (() => {
  const lang = allowedLanguages.includes(document.documentElement.lang as SupportedLanguage) ? 
    document.documentElement.lang : 'en'
  return lang // Default to 'en' if lang attribute is missing
})()

const options: InterpolationOptions = {
  formatSeparator: ',',
  alwaysFormat: false,
  escapeValue: true,
  useRawValueToEscape: false,
  prefix: '{{',
  suffix: '}}',
  unescapePrefix: '-',
  nestingPrefix: '$t(',
  nestingSuffix: ')',
  nestingOptionsSeparator: ',',
  maxReplaces: 1000,
  skipOnVariables: true,
}

/**
 * Function to interpolate a translation string with dynamic values.
 * This function directly uses the translation string (e.g. "Schließt um {{ time }}") 
 * and replaces the placeholders with provided replacement values.
 *
 * @param translationString - The translation string with placeholders (e.g. "Schließt um {{ time }}")
 * @param replacements - The values to replace the placeholders
 * @returns The interpolated translation string with placeholders replaced
 */
export function t(translationString: string, data?: Record<string, any>): string {
  i18next.init()
  // Replace placeholders with the provided values
  return i18next.services.interpolator.interpolate(translationString, data || {}, currentLanguage, options)
}
